import { DropDown } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import useOrdinal from "../../../hooks/useOrdinal";
import { PreferenceComponent } from "../PreferenceComponent";

export const NotificationsContent = ({
  taskApproachingEmailEnabledRef,
  taskApproachingDaysPriorRef,
  systemPreferences,
  onChange,
}) => {
  const { t, i18n } = useTranslation(["Preferences"]);
  const { dayNumberData } = useOrdinal();

  return (
    <div className="m-4 d-flex justify-content-between">
      <div className="col-3">
        <div className="fw-600">
          {t("SystemPreferences.NotificationsTitle")}
        </div>
        <div className="w-75 et-darkest-gray">
          {t("SystemPreferences.NotificationsSubtitle")}
        </div>
      </div>

      <div className="col-9">
        <div className="informative-banner p-3 mb-3">
          <div>
            <i className="fa-regular fa-circle-info informative-banner-icon"></i>
          </div>
          <div className="ps-3">
            <p className="informative-banner-message">
              {t("SystemPreferences.InformativeBannerMessage")}
            </p>
          </div>
        </div>

        <div className="notification-content">
          <PreferenceComponent
            ref={taskApproachingEmailEnabledRef}
            title={t("SystemPreferences.TaskApproaching")}
            checkedValue={systemPreferences?.TaskApproachingEmailEnabled}
            titleBold={true}
            change={onChange}
          />

          <div className="notification-content my-3 mx-5 bg-et-lightest-gray">
            <div className="m-4 d-flex align-items-center gap-3">
              <div>{t("SystemPreferences.NotifyTasks1")}</div>
              <div>
                <DropDown
                  ref={taskApproachingDaysPriorRef}
                  value={systemPreferences?.TaskApproachingDaysPrior}
                  dataSource={dayNumberData}
                  fields={{
                    text: "text",
                    value: "value",
                  }}
                  htmlFor="system-preference-day-value"
                  id="system-preference-day-value"
                  locale={i18n.language}
                  change={onChange}
                />
              </div>
              <div>{t("SystemPreferences.NotifyTasks2")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
